<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="upgrade-dialog"
  [style]="{ width: '500px', maxWidth: '90vw' }"
  [breakpoints]="{ '576px': '95vw' }"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <i class="pi pi-lock"></i>
      <h3>Upgrade to use {{ featureName }}</h3>
    </div>
  </ng-template>

  <div class="dialog-content">
    <p class="message">
      {{ tierName }} does not have access to {{ featureName }}.
    </p>
    <p class="message">
      To enable {{ featureName }}, please upgrade your subscription.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="UPGRADE NOW"
      icon="pi pi-arrow-up-right"
      (onClick)="onUpgrade()"
      [disabled]="!upgradeUrl"
      styleClass="p-button-primary"
    />
    <p-button
      label="CANCEL"
      (onClick)="onClose()"
      styleClass="p-button-text p-button-secondary"
    />
  </ng-template>
</p-dialog>
